import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface SendMessageApiProps extends CacheProps {
  mobile: string
  name: string
  title: string
  text: string
  token: string
}

const sendContactsMessageApi = ({ text, token, title, mobile, name, ...rest }: SendMessageApiProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.contacts.send.message'],
    payload: {
      mobile: mobile,
      full_name: name,
      title: title,
      description: text,
      token: token,
    },
    ...rest,
  });
};

export default sendContactsMessageApi;
